/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
import React from 'react';
import { Field, useFormikContext } from 'formik';

import { Input } from 'components/bootstrap';
import { Select } from 'components/common';
import type { DataLakeActionFormValues } from 'data-lake/Types';
import { DATA_LAKE_INCLUSION_TYPE, INDEXER_INCLUSION_TYPE, BOTH_INCLUSION_TYPE } from 'data-lake/Constants';

const INCLUSION_TYPE_OPTIONS = [
  { value: DATA_LAKE_INCLUSION_TYPE, label: 'Must exclude: Search Cluster' },
  { value: INDEXER_INCLUSION_TYPE, label: 'Must include: Search Cluster' },
  { value: BOTH_INCLUSION_TYPE, label: 'Include All' },
];

const InclusionTypeField = () => {
  const {
    errors,
    setFieldValue,
    values: { inclusionType },
  } = useFormikContext<DataLakeActionFormValues>();

  return (
    <Field name="inclusion_type">
      {() => (
        <Input
          help="Type of message to be retrieved"
          id="inclusion-type"
          error={errors.inclusionType}
          label="Filter Retrieval by Original Destination">
          <Select
            id="inclusionType"
            name="inclusionYype"
            placeholder="Select type of retrieval filter"
            options={INCLUSION_TYPE_OPTIONS}
            onChange={(option) => {
              setFieldValue('inclusionType', option);
            }}
            value={inclusionType}
          />
        </Input>
      )}
    </Field>
  );
};

export default InclusionTypeField;
